import axios from 'axios';
import { useMemo, useState, useEffect, ReactNode, useContext, createContext } from 'react';
import { Province } from 'src/type';

const API_URL =
  'https://raw.githubusercontent.com/KoonPorZaLearn/thai-province-data/refs/heads/master/api_province_with_amphure_tambon.json';

// 👉 2. สร้าง Context
interface ProvinceContextType {
  provinces: Province[];
  loading: boolean;
}

const ProvinceContext = createContext<ProvinceContextType | undefined>(undefined);

export const ProvinceProvider = ({ children }: { children: ReactNode }) => {
  const [provinces, setProvinces] = useState<Province[] | []>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const { data } = await axios.get(API_URL);
        setProvinces(data);
      } catch (error) {
        console.error('Error fetching provinces:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProvinces();
  }, []);

  return (
    <ProvinceContext.Provider value={useMemo(() => ({ provinces, loading }), [provinces, loading])}>
      {children}
    </ProvinceContext.Provider>
  );
};

// 👉 4. Custom Hook สำหรับเรียกใช้ Context
export const useProvinces = () => {
  const context = useContext(ProvinceContext);
  if (!context) {
    throw new Error('useProvinces must be used within a ProvinceProvider');
  }
  return context;
};
